import React from 'react';
import { Box, Button, CardMedia, Container, Grid, Typography } from '@mui/material';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import './PortfolioSlider.css'
import testimonial1 from '../../../../images/portfolio1.png';
import testimonial2 from '../../../../images/portfolio2.png';
import testimonialSm1 from '../../../../images/portfolio-sm1.png';
import testimonialSm2 from '../../../../images/portfolio-sm2.png';
import { NavLink } from 'react-router-dom';


const NextArrow = ({ onClick }) => {
    return (
        <Box sx={{ py: 1, px: { xs: 1.875, sm: 2.625, md: 3.375, lg: 4.125 } }} className="arrow next" onClick={onClick}>
            <i className="fas fa-arrow-right"></i>
        </Box>
    );
};

const PrevArrow = ({ onClick }) => {
    return (
        <Box sx={{ py: 1, px: { xs: 1.875, sm: 2.625, md: 3.375, lg: 4.125 } }} className="arrow prev" onClick={onClick}>
            <i className="fas fa-arrow-left"></i>
        </Box>
    );
};

export default function PortfolioSlider() {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2.1,
        slidesToScroll: 1,
        lazyLoad: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };
    return (
        <>
            <Box sx={{ position: 'relative', display: { sm: 'none', xs: 'none', md: 'inline' } }}>
                <Container>
                    <Slider {...settings}>
                        <Box sx={{ mb: { xs: 3.25, sm: 5.29, md: 7.33, lg: 9.375 }, ml: 5 }}>
                            <Grid container id="portfolio-hover" sx={{ width: { sm: '85%' }, background: '#FFFFFF', boxSizing: 'border-box', borderRadius: 2, pl: { xs: 1, sm: 1.3, md: 2.25, lg: 2.875, xl: 3.5 }, pt: { xs: 1, sm: 1.3, md: 2.25, lg: 2.875, xl: 3.5 }, pb: { xs: 1.125, sm: 1.79, md: 2.46, lg: 3.125, xl: 2.79 }, pr: { xs: 1, sm: 2.71, md: 3.67, lg: 4.625, xl: 5.59 }, m: 5 }}>

                                <Grid item sm={4} sx={{ display: { sm: 'flex' } }}>
                                    <CardMedia
                                        component="img"
                                        sx={{ width: '100%', }}
                                        image={testimonial1}
                                        alt=""
                                    />
                                </Grid>

                                <Grid item sm={8} sx={{ pl: { sm: 1.5, md: 2, lg: 2.4 }, textAlign: 'left' }}>
                                    <Typography
                                        sx={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: { sm: 17, md: 21, lg: 25 }, lineHeight: { sm: '21px', md: '32px' }, color: '#000D83', py: { sm: 1 } }} variant="h1" noWrap component="div"
                                    >Company Name</Typography>

                                    <Typography
                                        sx={{ fontWeight: { sm: 'normal', md: 400 }, fontStyle: 'normal', fontSize: { sm: 13, md: 17, lg: 20 }, lineHeight: { xs: '13px', sm: '21px' }, color: '#000D83', pb: { sm: 3.2, md: 4.4, lg: 5.5 } }} variant="h1" noWrap component="div"
                                    >Location</Typography>

                                    <Typography
                                        sx={{ fontWeight: { sm: 325 }, fontStyle: 'normal', fontSize: { md: 14, lg: 19 }, lineHeight: { sm: '26px', md: '33px', lg: '40px' }, color: '#5B5B5B' }} variant="h1" noWrap component="div"
                                    >Lorem ipsum dolor sit amet, <br /> consectetur asbi adipiscing <br /> Amet pharetra, amaecena. <br /> Adipiscing</Typography>
                                </Grid>
                            </Grid>
                        </Box>

                        <Box sx={{ ml: 5 }}>
                            <Grid container id="portfolio-hover" sx={{ width: { sm: '85%' }, background: '#FFFFFF', boxSizing: 'border-box', borderRadius: 2, pl: { xs: 1, sm: 1.3, md: 2.25, lg: 2.875, xl: 3.5 }, pt: { xs: 1, sm: 1.3, md: 2.25, lg: 2.875, xl: 3.5 }, pb: { xs: 1.125, sm: 1.79, md: 2.46, lg: 3.125, xl: 2.79 }, pr: { xs: 1, sm: 2.71, md: 3.67, lg: 4.625, xl: 5.59 }, m: 5 }}>

                                <Grid item sm={4} sx={{ display: { sm: 'flex' } }}>
                                    <CardMedia
                                        component="img"
                                        sx={{ width: '100%', }}
                                        image={testimonial2}
                                        alt=""
                                    />
                                </Grid>

                                <Grid item sm={8} sx={{ pl: { sm: 1.5, md: 2, lg: 2.4 }, textAlign: 'left' }}>
                                    <Typography
                                        sx={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: { sm: 17, md: 21, lg: 25 }, lineHeight: { sm: '21px', md: '32px' }, color: '#000D83', py: { sm: 1 } }} variant="h1" noWrap component="div"
                                    >Company Name</Typography>

                                    <Typography
                                        sx={{ fontWeight: { sm: 'normal', md: 400 }, fontStyle: 'normal', fontSize: { sm: 13, md: 17, lg: 20 }, lineHeight: { xs: '13px', sm: '21px' }, color: '#000D83', pb: { sm: 3.2, md: 4.4, lg: 5.5 } }} variant="h1" noWrap component="div"
                                    >Location</Typography>

                                    <Typography
                                        sx={{ fontWeight: { sm: 325 }, fontStyle: 'normal', fontSize: { md: 14, lg: 19 }, lineHeight: { sm: '26px', md: '33px', lg: '40px' }, color: '#5B5B5B' }} variant="h1" noWrap component="div"
                                    >Lorem ipsum dolor sit amet, <br /> consectetur asbi adipiscing <br /> Amet pharetra, amaecena. <br /> Adipiscing</Typography>
                                </Grid>
                            </Grid>
                        </Box>

                        <Box sx={{ ml: 5 }}>
                            <Grid container id="portfolio-hover" sx={{ width: { sm: '85%' }, background: '#FFFFFF', boxSizing: 'border-box', borderRadius: 2, pl: { xs: 1, sm: 1.3, md: 2.25, lg: 2.875, xl: 3.5 }, pt: { xs: 1, sm: 1.3, md: 2.25, lg: 2.875, xl: 3.5 }, pb: { xs: 1.125, sm: 1.79, md: 2.46, lg: 3.125, xl: 2.79 }, pr: { xs: 1, sm: 2.71, md: 3.67, lg: 4.625, xl: 5.59 }, m: 5 }}>

                                <Grid item sm={4} sx={{ display: { sm: 'flex' } }}>
                                    <CardMedia
                                        component="img"
                                        sx={{ width: '100%', }}
                                        image={testimonial1}
                                        alt=""
                                    />
                                </Grid>

                                <Grid item sm={8} sx={{ pl: { sm: 1.5, md: 2, lg: 2.4 }, textAlign: 'left' }}>
                                    <Typography
                                        sx={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: { sm: 17, md: 21, lg: 25 }, lineHeight: { sm: '21px', md: '32px' }, color: '#000D83', py: { sm: 1 } }} variant="h1" noWrap component="div"
                                    >Company Name</Typography>

                                    <Typography
                                        sx={{ fontWeight: { sm: 'normal', md: 400 }, fontStyle: 'normal', fontSize: { sm: 13, md: 17, lg: 20 }, lineHeight: { xs: '13px', sm: '21px' }, color: '#000D83', pb: { sm: 3.2, md: 4.4, lg: 5.5 } }} variant="h1" noWrap component="div"
                                    >Location</Typography>

                                    <Typography
                                        sx={{ fontWeight: { sm: 325 }, fontStyle: 'normal', fontSize: { md: 14, lg: 19 }, lineHeight: { sm: '26px', md: '33px', lg: '40px' }, color: '#5B5B5B' }} variant="h1" noWrap component="div"
                                    >Lorem ipsum dolor sit amet, <br /> consectetur asbi adipiscing <br /> Amet pharetra, amaecena. <br /> Adipiscing</Typography>
                                </Grid>
                            </Grid>
                        </Box>

                        <Box sx={{ ml: 5 }}>
                            <Grid container id="portfolio-hover" sx={{ width: { sm: '85%' }, background: '#FFFFFF', boxSizing: 'border-box', borderRadius: 2, pl: { xs: 1, sm: 1.3, md: 2.25, lg: 2.875, xl: 3.5 }, pt: { xs: 1, sm: 1.3, md: 2.25, lg: 2.875, xl: 3.5 }, pb: { xs: 1.125, sm: 1.79, md: 2.46, lg: 3.125, xl: 2.79 }, pr: { xs: 1, sm: 2.71, md: 3.67, lg: 4.625, xl: 5.59 }, m: 5 }}>

                                <Grid item sm={4} sx={{ display: { sm: 'flex' } }}>
                                    <CardMedia
                                        component="img"
                                        sx={{ width: '100%', }}
                                        image={testimonial2}
                                        alt=""
                                    />
                                </Grid>

                                <Grid item sm={8} sx={{ pl: { sm: 1.5, md: 2, lg: 2.4 }, textAlign: 'left' }}>
                                    <Typography
                                        sx={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: { sm: 17, md: 21, lg: 25 }, lineHeight: { sm: '21px', md: '32px' }, color: '#000D83', py: { sm: 1 } }} variant="h1" noWrap component="div"
                                    >Company Name</Typography>

                                    <Typography
                                        sx={{ fontWeight: { sm: 'normal', md: 400 }, fontStyle: 'normal', fontSize: { sm: 13, md: 17, lg: 20 }, lineHeight: { xs: '13px', sm: '21px' }, color: '#000D83', pb: { sm: 3.2, md: 4.4, lg: 5.5 } }} variant="h1" noWrap component="div"
                                    >Location</Typography>

                                    <Typography
                                        sx={{ fontWeight: { sm: 325 }, fontStyle: 'normal', fontSize: { md: 14, lg: 19 }, lineHeight: { sm: '26px', md: '33px', lg: '40px' }, color: '#5B5B5B' }} variant="h1" noWrap component="div"
                                    >Lorem ipsum dolor sit amet, <br /> consectetur asbi adipiscing <br /> Amet pharetra, amaecena. <br /> Adipiscing</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </Slider>
                </Container>
            </Box>
            <Box sx={{ display: { sm: 'inline', xs: 'inline', md: 'none' } }}>
                <Box sx={{ mt: 6, mb: 5 }}>
                    <Grid container sx={{ width: '85%', mx: 'auto', background: '#FFFFFF', boxShadow: ' 0px 0px 7px rgba(0, 82, 224, 0.16)', borderRadius: 2, pt: { xs: 1, sm: 1.3 }, pb: { xs: 1.125, sm: 1.79 } }}>

                        <Grid item xs={5} sm={6} sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '90%', }}
                                image={testimonialSm2}
                                alt=""
                            />
                        </Grid>

                        <Grid item xs={7} sm={6} sx={{ pl: 1.5, textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                            <Box>
                                <Typography
                                    sx={{ fontWeight: 500, fontStyle: 'normal', fontSize: { xs: 14, sm: 24 }, lineHeight: '18px', color: '#000D83', py: { sm: 2 } }} variant="h1" noWrap component="div"
                                >Company Name</Typography>

                                <Typography
                                    sx={{ fontWeight: 400, fontStyle: 'normal', fontSize: { xs: 12, sm: 18 }, lineHeight: '16px', color: '#000D83', pb: 3 }} variant="h1" noWrap component="div"
                                >Location</Typography>
                                <Box>
                                    <Typography sx={{ fontWeight: 300, fontStyle: 'normal', fontSize: { xs: 12, sm: 15 }, lineHeight: { xs: '7px', sm: '10px' }, color: '#5B5B5B', pb: 3 }} variant="h1" noWrap component="div"
                                    ><i style={{ marginRight: '5px', color: '#FF5358' }} className="fas fa-check"></i> Design & Development</Typography>
                                    <Typography sx={{ fontWeight: 300, fontStyle: 'normal', fontSize: { xs: 12, sm: 15 }, lineHeight: { xs: '7px', sm: '10px' }, color: '#5B5B5B', pb: 3 }} variant="h1" noWrap component="div"
                                    ><i style={{ marginRight: '5px', color: '#FF5358' }} className="fas fa-check"></i>Digital Marketing</Typography>
                                    <Typography sx={{ fontWeight: 300, fontStyle: 'normal', fontSize: { xs: 12, sm: 15 }, lineHeight: { xs: '7px', sm: '10px' }, color: '#5B5B5B', pb: 3 }} variant="h1" noWrap component="div"
                                    ><i style={{ marginRight: '5px', color: '#FF5358' }} className="fas fa-check"></i>Digital Marketing</Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ textAlign: 'left', width: '83%', mx: 'auto' }}>
                    <NavLink to='' style={{ textDecoration: 'none' }}>
                        <Button sx={{ textDecoration: 'none', fontSize: '18px', lineHeight: '27px', color: "#000D83", fontWeight: 600, width: '150px', height: '42px', border: '1px solid #000D83', mr: 3 }} style={{ textTransform: 'capitalize' }} id="service-button">
                            Learn More <i style={{ paddingLeft: '10px' }} className="fas fa-long-arrow-alt-right"></i>
                        </Button>
                    </NavLink>
                </Box>
                <Box sx={{ mt: 6, mb: 5 }}>
                    <Grid container sx={{ width: '85%', mx: 'auto', background: '#FFFFFF', boxShadow: ' 0px 0px 7px rgba(0, 82, 224, 0.16)', borderRadius: 2, pt: { xs: 1, sm: 1.3 }, pb: { xs: 1.125, sm: 1.79 } }}>

                        <Grid item xs={5} sm={6} sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '90%', }}
                                image={testimonialSm1}
                                alt=""
                            />
                        </Grid>

                        <Grid item xs={7} sm={6} sx={{ pl: 1.5, textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                            <Box>
                                <Typography
                                    sx={{ fontWeight: 500, fontStyle: 'normal', fontSize: { xs: 14, sm: 24 }, lineHeight: '18px', color: '#000D83', py: { sm: 2 } }} variant="h1" noWrap component="div"
                                >Company Name</Typography>

                                <Typography
                                    sx={{ fontWeight: 400, fontStyle: 'normal', fontSize: { xs: 12, sm: 18 }, lineHeight: '16px', color: '#000D83', pb: 3 }} variant="h1" noWrap component="div"
                                >Location</Typography>
                                <Box>
                                    <Typography sx={{ fontWeight: 300, fontStyle: 'normal', fontSize: { xs: 12, sm: 15 }, lineHeight: { xs: '7px', sm: '10px' }, color: '#5B5B5B', pb: 3 }} variant="h1" noWrap component="div"
                                    ><i style={{ marginRight: '5px', color: '#FF5358' }} className="fas fa-check"></i> Design & Development</Typography>
                                    <Typography sx={{ fontWeight: 300, fontStyle: 'normal', fontSize: { xs: 12, sm: 15 }, lineHeight: { xs: '7px', sm: '10px' }, color: '#5B5B5B', pb: 3 }} variant="h1" noWrap component="div"
                                    ><i style={{ marginRight: '5px', color: '#FF5358' }} className="fas fa-check"></i>Digital Marketing</Typography>
                                    <Typography sx={{ fontWeight: 300, fontStyle: 'normal', fontSize: { xs: 12, sm: 15 }, lineHeight: { xs: '7px', sm: '10px' }, color: '#5B5B5B', pb: 3 }} variant="h1" noWrap component="div"
                                    ><i style={{ marginRight: '5px', color: '#FF5358' }} className="fas fa-check"></i>Digital Marketing</Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ textAlign: 'left', width: '83%', mx: 'auto' }}>
                    <NavLink to='' style={{ textDecoration: 'none' }}>
                        <Button sx={{ textDecoration: 'none', fontSize: '18px', lineHeight: '27px', color: "#000D83", fontWeight: 600, width: '150px', height: '42px', border: '1px solid #000D83', mr: 3 }} style={{ textTransform: 'capitalize' }} id="service-button">
                            Learn More <i style={{ paddingLeft: '10px' }} className="fas fa-long-arrow-alt-right"></i>
                        </Button>
                    </NavLink>
                </Box>
            </Box>
        </>
    );
}